import { useParamValue } from "PFCore/hooks/use_param_value";
import { SkillsFrameworkRank } from "PFTypes";
import { useHistory, useParams } from "react-router-dom";

type SkillsFrameworksListPageParams = {
  tab: SkillsFrameworkRank;
};

export const useSkillsFrameworksTab = () => {
  const { tab } = useParams<SkillsFrameworksListPageParams>();
  const history = useHistory();

  const { value: page = 1, setValue: setPage } = useParamValue<number>("page", {
    parse: (raw) => (raw === null ? 1 : parseInt(raw)),
    isEmpty: (value) => value === 1
  });

  const handleTabChange = (tab: SkillsFrameworkRank) => {
    history.push(`/admin/skills_frameworks/${tab}`);
    setPage(1);
  };

  return { page, setPage, activeTab: tab, changeTab: handleTabChange };
};
